import ElectricBoltIcon from '@mui/icons-material/ElectricBolt'
import { AppBar, Box, IconButton, Toolbar } from '@mui/material'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import DocsSearchButton from '@/features/docs/search/DocsSearchButton'
import MenuIcon from '@/icons/Menu'
import DocsCategoriesMenu from './DocsCategoriesMenu'

const DocsNavbar = ({ onSidebarMobileOpen }) => (
    <AppBar
        sx={(theme) => ({
            backgroundColor: 'background.paper',
            color: 'text.primary',
            boxShadow: 'none',
            borderBottom: `1px solid ${theme.palette.divider}`,
            zIndex: theme.zIndex.drawer + 100,
            pl: 'env(safe-area-inset-left, 0px)',
            pr: 'env(safe-area-inset-right, 0px)'
        })}
    >
        <Toolbar sx={{ height: 64 }}>
            <IconButton
                color="inherit"
                onClick={onSidebarMobileOpen}
                sx={{
                    display: {
                        lg: 'none'
                    }
                }}
            >
                <MenuIcon fontSize="small" />
            </IconButton>
            <RouterLink to="/">
                <ElectricBoltIcon
                    sx={(theme) => ({
                        fontSize: 40,
                        // The selected accent colour resolves to the theme's
                        // primary palette; fall back to inherit if unavailable.
                        color: theme.palette?.primary?.main ?? 'inherit',
                        display: {
                            lg: 'inline',
                            xs: 'none'
                        }
                    })}
                />
            </RouterLink>
            <Box sx={{ flexGrow: 1 }} />
            {/*
             * Browse and search, side by side and present at every width.
             * The sidebar collapses into a temporary drawer below `lg`, so
             * this is the only way between categories on a phone.
             */}
            <DocsCategoriesMenu />
            <DocsSearchButton />
        </Toolbar>
    </AppBar>
)

DocsNavbar.propTypes = {
    onSidebarMobileOpen: PropTypes.func
}

export default DocsNavbar
